import { Box } from "@mui/material";
import { useTranslation } from "next-i18next";
import { ITagsData, ITags, IKeyFigureGroup, IKeyFiguresData } from "src/api/server/extended-search.types";
import { KeyFiguresPopover } from "src/components/pages/search/components/key-figures-filter/key-figures-popover";
import { PopularFiltersPopover } from "src/components/pages/search/components/popular-filters/popular-filters-popover";
import { TagsPopover } from "src/components/pages/search/components/tags-filter/tags-popover";
import { Button } from "src/components-mui/base/button/button";
import { Container } from "src/components-mui/layout/container";
import { SearchFilterHeader } from "../search-filter-header";
import { SearchResultCount } from "../search-result-count";
import { SearchFilterInvestableSwitches } from "./search-filter-investable-switches";

const SEARCH_FILTER_CONTAINER_TEST_ID = "search-filter-container";

interface ISearchFilterProps {
    resultCount: number | null;
    popularKeyFiguresGroup: IKeyFigureGroup;
    popularTags: ITags;
    keyFiguresData: IKeyFiguresData;
    tagsData: ITagsData;
    onSearchTermClear: () => void;
    onReset: () => void;
    searchTerm?: string | string[];
}

export const SearchFilterContainer = ({
    searchTerm,
    resultCount,
    popularKeyFiguresGroup,
    popularTags,
    keyFiguresData,
    tagsData,
    onSearchTermClear,
    onReset,
}: ISearchFilterProps) => {
    const { t } = useTranslation("extended-search");

    return (
        <Box
            component="section"
            data-test-id={SEARCH_FILTER_CONTAINER_TEST_ID}
            sx={{
                bgcolor: "gray.50",
                display: ["none", "block"],
            }}
        >
            <Container sx={{ pt: 7, pb: 5 }}>
                <SearchFilterHeader searchTerm={searchTerm} handleOnClear={onSearchTermClear} />
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 2,
                    }}
                >
                    <SearchResultCount resultCount={resultCount} sx={{ alignSelf: "center" }} />
                    <Button variant="ghost-underline" size="small" onClick={onReset} sx={{ px: 1 }}>
                        {t("buttons.reset-search-criteria")}
                    </Button>
                </Box>
                <Box>
                    <Box
                        sx={{
                            display: "flex",
                            gap: 2,
                            mb: 3,
                            width: "100%",
                        }}
                    >
                        <PopularFiltersPopover popularKeyFiguresGroup={popularKeyFiguresGroup} tagsData={popularTags} />
                        <KeyFiguresPopover keyFiguresData={keyFiguresData} />
                        <TagsPopover tagsData={tagsData} />
                    </Box>
                    <SearchFilterInvestableSwitches />
                </Box>
            </Container>
        </Box>
    );
};
